import SubscriptionClient from 'scripts/clients/robox-api/SubscriptionClient';
import maskInputDataCreditCard from 'scripts/miscellaneous/maskInputDataCreditCard.js';

export default {
    init() {
        const elCustomerUpdateSubscription = document.querySelector('#customer-update-subscription');
        const elPaymentPlanName = elCustomerUpdateSubscription.querySelector('.payment-plan-name');
        const elPaymentPlanId = elCustomerUpdateSubscription.querySelector('.payment-plan-id');
        const elDivCards = elCustomerUpdateSubscription.querySelector('#div-cards');
        const elTemplateCreditCardSalved = elDivCards.querySelector('.template-credit-card-salved');
        const elCreditCardNew = elDivCards.querySelector('.credit-card-new');
        const elButtonSaveCreditCard = elCustomerUpdateSubscription.querySelector('#save-card');

        const generateMessages = (rawData) => {
            let messages = [];

            rawData.forEach((itemError) => {
                if (itemError.meta.hasOwnProperty('validation_exception')) {
                    let validationException = itemError.meta.validation_exception;

                    Object.keys(validationException).forEach((key) => {
                        validationException[key].forEach((message) => {
                            messages.push(message)
                        })
                    });
                } else {
                    messages.push(itemError.detail)
                }
            });

            return messages;
        };

        const alertMessages = (message = '', collectionMessages = [], alertType = 'success') => {
            const elAlertMessages = document.getElementById('alert-messages');
            elAlertMessages.innerHTML = '';

            if (message) {
                const elPrimaryItemMessage = document.createElement('div');
                elPrimaryItemMessage.setAttribute('class', `alert alert-${alertType} text-center`);
                elPrimaryItemMessage.setAttribute('role', 'alert');
                elPrimaryItemMessage.innerHTML = message;
                elAlertMessages.appendChild(elPrimaryItemMessage);
            }

            collectionMessages.forEach((m) => {
                const elItemMessage = document.createElement('div');
                elItemMessage.setAttribute('class', `alert alert-${alertType} text-center`);
                elItemMessage.setAttribute('role', 'alert');
                elItemMessage.innerHTML = m;
                elAlertMessages.appendChild(elItemMessage);
            });
        };

        const triggerEvent = (el, type) => {
            const eventHandle = document.createEvent('HTMLEvents');
            eventHandle.initEvent(type, false, true);
            el.dispatchEvent(eventHandle);
        };

        const submitCreditCard = (token) => {
            elButtonSaveCreditCard.addEventListener('click', (event) => {
                document.body.style.cursor = 'wait';
                const elButtonSave = event.target;
                elButtonSave.innerHTML = 'SALVANDO...';
                elButtonSave.setAttribute('disabled', 'disabled');

                triggerEvent(document.querySelector('#form-payment-new'), 'submit');
            });

            document.getElementById('form-payment-new').addEventListener('submit', (event) => {
                event.preventDefault();
                const form = event.target;
                const valueCreditCardChecked = elDivCards.querySelector('input[name=card]:checked').value;
                let params = {};

                if(valueCreditCardChecked === 'new') {
                    params = {
                        card: {
                            number: form.number.value.replace(/\D/g, ''),
                            holder_name: form.holder_name.value,
                            exp_month: form.exp_month.value,
                            exp_year: form.exp_year.value,
                            cvv: form.cvv.value,
                            brand: form.brand.value,
                        },
                        payment_method: 'credit_card',
                    };
                } else {
                    params = {
                        card: {
                            card_id: valueCreditCardChecked,
                        },
                        payment_method: 'credit_card',
                    };
                }

                new SubscriptionClient()
                    .updateByUpdatePaymentDataToken(token, params)
                    .then((response) => {
                        elButtonSaveCreditCard.innerHTML = 'PROCESSANDO...';

                        alertMessages(response.meta.message);

                        readLatestPurchaseByUpdatePaymentDataToken(response.meta.token)
                    })
                    .catch((response) => {
                        alertMessages('', generateMessages(response.responseJSON.errors), 'danger');
                        document.body.style.cursor = 'default';
                        elButtonSaveCreditCard.innerHTML = 'SALVAR';
                        elButtonSaveCreditCard.removeAttribute('disabled');
                    });
            });
        };

        const validationTokenPattern = () => {
            try {
                /* eslint-disable-next-line */
                const regex = /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/;
                const uri = window.location.pathname;

                const token = regex.exec(uri).pop();

                return token;
            } catch (error) {
                alertMessages('Falha no padrão do token.', [], 'danger');

                return null;
            }
        };

        const readByUpdatePaymentDataToken = (token) => {
            if (token === null) return;

            let subscription = {};
            let cards = [];
            let plan = {};

            new SubscriptionClient()
                .readByUpdatePaymentDataToken(token)
                .then((response) => {
                    // FIXME - ROB-104 - refactor
                    subscription = response.data.attributes;
                    cards = response.meta.cards.data;
                    plan = response.data.relationships.plan.data.attributes;
                    elPaymentPlanName.textContent = plan.name;
                    elPaymentPlanId.append(subscription.id);

                    cards.forEach(({attributes}) => {
                        const card = attributes;
                        const elClonedCreditCardSalved = elTemplateCreditCardSalved.cloneNode(true);
                        elClonedCreditCardSalved.classList.add('d-flex');
                        elClonedCreditCardSalved.classList.remove('d-none');
                        elClonedCreditCardSalved.classList.remove('template-credit-card-salved');

                        elClonedCreditCardSalved.querySelector('input').value = card.id;
                        elClonedCreditCardSalved.querySelector('input').checked = subscription.card_id === card.id;
                        elClonedCreditCardSalved.querySelector('input').setAttribute('id', `card-${card.id}`);
                        elClonedCreditCardSalved.querySelector('.card-brand').classList.add(card.brand);
                        elClonedCreditCardSalved.querySelector('.radio-card-four-digits').textContent = card.last_four_digits;

                        elDivCards.insertBefore(elClonedCreditCardSalved, elCreditCardNew);
                    });

                    elCustomerUpdateSubscription.classList.remove('d-none');
                    elTemplateCreditCardSalved.remove();
                })
                .catch((response) => {
                    alertMessages('', generateMessages(response.responseJSON.errors), 'danger');
                });
        };

        const repeatAnything = (
            handleInterval = properties => properties,
            handleClear = properties => properties,
            clear = false,
            period = 5000,
            limitK = 60
        ) => {
            let limit = limitK * 1e3;
            let nTry = 0;
            const intervalID = setInterval(() => {
                clear = clear || (limit / period <= ++nTry);

                handleInterval({
                    cycles: limit / period,
                    numberOfAttempts: nTry,
                });

                if (clear) {
                    clearInterval(intervalID);
                    handleClear({
                        clear,
                    });
                }
            }, period);
        };

        const readLatestPurchaseByUpdatePaymentDataToken = (token) => {
            const elProgressBarStatus = document.querySelector('#progress-bar-status');
            const elProgressBar = elProgressBarStatus.querySelector('.progress .progress-bar');
            let purchase = {};

            repeatAnything(
                (properties) => {
                    const unitPercent = 100 / properties.cycles;
                    let currentPercent = Math.round(unitPercent * properties.numberOfAttempts);
                    currentPercent = currentPercent > 100 ? 100 : currentPercent;

                    new SubscriptionClient()
                        .readLatestPurchaseByUpdatePaymentDataToken(token)
                            .then((response) => {
                                purchase = response.data.attributes;

                                if (purchase.status === 'active') {
                                    alertMessages('Cobrança realizada com sucesso!', []);

                                    elProgressBarStatus.classList.add('d-none');
                                    setTimeout(() => {
                                        window.location.href="/";
                                    }, 7000);
                                } else {
                                    elProgressBarStatus.classList.remove('d-none');
                                    elProgressBar.setAttribute('style', `width: ${currentPercent}%`);
                                    elProgressBar.setAttribute('aria-valuenow', currentPercent);

                                    alertMessages('Tentativa de cobrança em andamento...', [], 'warning');
                                }
                            })
                            .catch((response) => {
                                alertMessages('', generateMessages(response.responseJSON.errors), 'danger');
                            })
                            .finally(() => {
                                if (purchase.status != 'active' && currentPercent === 100) {
                                    elProgressBar.classList.remove('bg-warning');
                                    elProgressBar.classList.add('bg-danger');
                                    alertMessages('A cobrança não deu certo, tente novamente com outro cartão de crédito!', [], 'danger');

                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 7000);
                                }
                            });
                }
            );
        };

        // run -----------------------------------------------------------------
        maskInputDataCreditCard();
        readByUpdatePaymentDataToken(validationTokenPattern())
        submitCreditCard(validationTokenPattern());

    },
    finalize () {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/pages/customerUpdateSubscription.js